/**
 * Компонент полноэкранной загрузки
 * 
 * Отображает спиннер по центру экрана с настраиваемым текстом.
 * Используется для страниц в состоянии загрузки.
 * 
 * @example
 * // Простой экран загрузки
 * <LoadingScreen />
 * 
 * @example
 * // С кастомным текстом
 * <LoadingScreen text="Загружаем профиль..." />
 * 
 * @example
 * // Без нижнего отступа
 * <LoadingScreen hasBottomPadding={false} />
 */

import { Spinner } from '@/components/ui/spinner';

interface LoadingScreenProps {
  /** Текст под спиннером (опционально) */
  text?: string;
  /** Добавить нижний отступ для bottom menu (по умолчанию true) */
  hasBottomPadding?: boolean;
  /** Дополнительные CSS классы */
  className?: string;
}

export function LoadingScreen({ 
  text, 
  hasBottomPadding = true,
  className = ''
}: LoadingScreenProps): JSX.Element {
  return (
    <div className={`min-h-screen bg-background flex items-center justify-center ${hasBottomPadding ? 'pb-20' : ''} ${className}`}>
      <div className="text-center">
        <Spinner className="w-8 h-8 text-accent mx-auto" />
        {text && (
          <p className="text-muted-foreground mt-4">{text}</p>
        )}
      </div>
    </div>
  );
}